/* SEARCH STEERING MAP (window.FE_STEER): the one list of search words -> collections, per Wade's reviewed v3 spreadsheet
   (site-audit/search-steering-v3-review.xlsx, 2026-09-01: hub-only, no audience children; cross-sell rows he approved
   stay). Read by the header search dropdown (snippets/header-search.liquid) and by the search results page
   (sections/main-search.liquid), so a change here changes both. ORDER MATTERS: first match wins - stones/styles/materials
   before colors, colors before occasion words. Moved here from snippets/fe-steer-map.liquid by Round 1 decision #23
   (javascript-10, Wade 2026-10-13). The counts (n) stay live: that snippet prints them on this script tag's data-counts
   attribute (collection handle -> product count); a handle missing there gives 0 and the pill shows no count, so keep
   its handle list in step with the hrefs below. Idempotent: loading this file twice keeps the first copy. */
window.FE_STEER = window.FE_STEER || (function (script) {
  var COUNTS = {};
  try { COUNTS = JSON.parse((script && script.getAttribute('data-counts')) || '{}') || {}; } catch (e) { COUNTS = {}; }
  function count(handle) { return Object.prototype.hasOwnProperty.call(COUNTS, handle) ? (Number(COUNTS[handle]) || 0) : 0; }
  var MAP = [
    { hit: ['purp', 'amethyst', 'alexandr'], links: [
        { label: 'Purple Rings', sub: 'Amethyst, alexandrite & nebula bands - shop the collection', href: '/collections/purple-rings', n: count('purple-rings') }
      ] },
    { hit: ['moss', 'agat'], links: [
        { label: 'Moss Agate Engagement Rings', href: '/collections/moss-agate-rings', n: count('moss-agate-rings') },
        { label: 'Nature-Inspired Rings', href: '/collections/nature-inspired-rings', n: count('nature-inspired-rings') }
      ] },
    { hit: ['opal'], links: [
        { label: 'Opal Rings', sub: 'Shop the opal collection', href: '/collections/opal-rings', n: count('opal-rings') }
      ] },
    { hit: ['meteor'], links: [
        { label: 'Meteorite Rings', href: '/collections/meteorite-rings', n: count('meteorite-rings') },
        { label: 'Exotic Materials', href: '/collections/exotic-material-rings', n: count('exotic-material-rings') },
        { label: 'Dinosaur Bone Rings', href: '/collections/dinosaur-bone-rings', n: count('dinosaur-bone-rings') }
      ] },
    { hit: ['dino', 'fossil'], links: [
        { label: 'Dinosaur Bone Rings', href: '/collections/dinosaur-bone-rings', n: count('dinosaur-bone-rings') },
        { label: 'Exotic Materials', href: '/collections/exotic-material-rings', n: count('exotic-material-rings') },
        { label: 'Meteorite Rings', href: '/collections/meteorite-rings', n: count('meteorite-rings') }
      ] },
    { hit: ['nebula', 'galaxy', 'space', 'cosmos'], links: [
        { label: 'Galaxy-Inspired Space Rings', sub: 'Shop galaxy & space-inspired rings', href: '/collections/space-rings', n: count('space-rings') }
      ] },
    { hit: ['nature', 'leaf', 'forest'], links: [
        { label: 'Nature-Inspired Rings', sub: 'Shop nature-inspired rings', href: '/collections/nature-inspired-rings', n: count('nature-inspired-rings') }
      ] },
    { hit: ['acotar', 'thorns', 'velaris'], links: [
        { label: 'ACOTAR-Inspired Rings', sub: 'Shop ACOTAR-inspired rings', href: '/collections/a-court-of-thorns-and-roses-inspired-rings', n: count('a-court-of-thorns-and-roses-inspired-rings') }
      ] },
    { hit: ['fantasy', 'fae'], links: [
        { label: 'Fantasy Engagement Rings', href: '/collections/fantasy-rings', n: count('fantasy-rings') },
        { label: 'ACOTAR-Inspired Rings', href: '/collections/a-court-of-thorns-and-roses-inspired-rings', n: count('a-court-of-thorns-and-roses-inspired-rings') }
      ] },
    { hit: ['goth'], links: [
        { label: 'Gothic Couples Rings', sub: 'Shop the gothic couples collection', href: '/collections/lovers-of-the-dark-couples-rings', n: count('lovers-of-the-dark-couples-rings') }
      ] },
    { hit: ['lotus'], links: [
        { label: 'Lotus Rings', sub: 'Shop the lotus collection', href: '/collections/lotus-rings', n: count('lotus-rings') }
      ] },
    { hit: ['glow'], links: [
        { label: 'Glow-in-the-Dark Rings', sub: 'Shop glow-in-the-dark rings', href: '/collections/glow-in-the-dark-rings', n: count('glow-in-the-dark-rings') }
      ] },
    { hit: ['wood'], links: [
        { label: 'Wood Rings', href: '/collections/wood-rings', n: count('wood-rings') },
        { label: 'Whiskey Barrel Rings', href: '/collections/whiskey-barrel-rings', n: count('whiskey-barrel-rings') }
      ] },
    { hit: ['whisk', 'bourbon'], links: [
        { label: 'Whiskey Barrel Rings', href: '/collections/whiskey-barrel-rings', n: count('whiskey-barrel-rings') },
        { label: 'Wood Rings', href: '/collections/wood-rings', n: count('wood-rings') }
      ] },
    { hit: ['tungsten'], links: [
        { label: "Men's Tungsten Wedding Bands", href: '/collections/tungsten-rings-for-men', n: count('tungsten-rings-for-men') },
        { label: "Women's Wedding Bands", href: '/collections/womens-wedding-bands', n: count('womens-wedding-bands') },
        { label: 'Couples Wedding Band Sets', href: '/collections/wedding-bands-for-couples', n: count('wedding-bands-for-couples') }
      ] },
    { hit: ['classic', 'simple', 'plain'], links: [
        { label: 'Classic Wedding Bands', sub: 'Shop classic wedding bands', href: '/collections/classic-wedding-bands', n: count('classic-wedding-bands') }
      ] },
    { hit: ['rose gold'], links: [
        { label: 'Rose Gold Rings', sub: 'Shop rose gold rings', href: '/collections/rose-gold-rings', n: count('rose-gold-rings') }
      ] },
    { hit: ['gold'], links: [
        { label: 'Gold Plated Rings', sub: 'Shop gold rings', href: '/collections/gold-rings', n: count('gold-rings') }
      ] },
    { hit: ['silver'], links: [
        { label: 'Silver Rings', sub: 'Shop silver rings', href: '/collections/silver-rings', n: count('silver-rings') }
      ] },
    { hit: ['black'], links: [
        { label: 'Black Wedding Rings', sub: 'Shop black rings', href: '/collections/black-rings', n: count('black-rings') }
      ] },
    { hit: ['necklace', 'earring'], links: [
        { label: 'Necklaces and Earrings', sub: 'Shop necklaces and earrings', href: '/collections/necklaces-and-earrings', n: count('necklaces-and-earrings') }
      ] },
    { hit: ['promise'], links: [
        { label: 'Promise Rings', sub: 'Shop all promise rings', href: '/collections/promise-rings', n: count('promise-rings') }
      ] },
    { hit: ['engagement'], links: [
        { label: 'Engagement Rings', sub: 'Shop all engagement rings', href: '/collections/engagement-rings', n: count('engagement-rings') }
      ] },
    { hit: ['wedding band', 'wedding ring'], links: [
        { label: 'Wedding Bands', sub: 'Shop all wedding bands', href: '/collections/wedding-bands', n: count('wedding-bands') }
      ] },
    { hit: ['couple', 'matching', 'his and her'], links: [
        { label: 'Couples Rings', sub: 'Shop all couples rings', href: '/collections/couples-rings', n: count('couples-rings') }
      ] }
  ];
  /* substring match on the typed text, first row wins; nothing under 4 characters */
  function match(q) {
    q = (q || '').trim().toLowerCase();
    if (q.length < 4) return null;
    for (var i = 0; i < MAP.length; i++) {
      for (var j = 0; j < MAP[i].hit.length; j++) {
        if (q.indexOf(MAP[i].hit[j]) !== -1) return MAP[i];
      }
    }
    return null;
  }
  return { MAP: MAP, match: match };
})(document.currentScript);
